import { ReactComponent as DesktopIcon } from "assets/images/svg/MoreColoursDropdown.svg";
import Icon from "./Icon";
import { FunctionComponent } from "react";

const MoreColoursDropdown: FunctionComponent = () => {
  return <Icon icon={<DesktopIcon />} />;
};

export default MoreColoursDropdown;
